import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/WallpaperCalculator/wallpaperCalculator.container"
    ).then((module) => ({
        default: module.WallpaperCalculator
    }))
);
